import React from 'react';
import {Button, Col, Form, Input, Row} from "antd";
import {FormattedMessage, useIntl} from "react-intl";
import {PlusOutlined, SearchOutlined} from "@ant-design/icons";
import {isMobileOnly} from "react-device-detect";

interface SearchFormProps {
    keyword: string;
    setKeyword: Function;
    loadData: Function;
    onAddButtonClick: () => void;
}

const ClinicSearchForm = ({keyword, setKeyword, loadData, onAddButtonClick}: SearchFormProps) => {
    const intl = useIntl();

    return (
        <Form layout="horizontal" className="mt-2">
            <Row gutter={16}>
                <Col flex={5}>
                    <Form.Item
                        name="keyword"
                        className={"dentobook-form-item"}
                    >
                        <Input value={keyword}
                               placeholder={intl.formatMessage({id: 'search'})}
                               onChange={e => setKeyword(e.target.value)}
                               prefix={<SearchOutlined style={{fontSize: 24}}/>}
                        />
                    </Form.Item>
                </Col>
                <Col flex={0}>
                    <Button shape="round"
                            className={isMobileOnly ? "mobile-add-btn" : "dentobook-btn-primary dentobook-btn-medium"}
                            style={{float: 'right', marginTop: '5px', marginLeft: '16px'}}
                            onClick={() => onAddButtonClick()}
                            type="primary"><PlusOutlined/> <FormattedMessage id="add"/></Button>

                </Col>
            </Row>
            <Button type="link" htmlType="submit" onClick={() => loadData(true)}></Button>

        </Form>
    );
};


export default ClinicSearchForm;
